<template>
    <common></common>
</template>
<script>
import common from './common.vue';

export default {
    name: 'commercialInvoiceAdd',
    components: {
        common,
    },
};
</script>
